// extracted by mini-css-extract-plugin
module.exports = {"unsupportedBrowserContainer":"UnsupportedBrowser_unsupportedBrowserContainer__1anF6"};